import * as React from "react"
import OrderResultRecordIdentifier from "../../api/OrderResults/OrderResultModel/OrderResultRecordIdentifier"
import Checkbox from "../Checkbox"

export interface OrderTrackingCheckboxProps {
  idPrefix: string
  item: OrderResultRecordIdentifier
  checked: boolean
  onChange: (item: OrderResultRecordIdentifier, checked: boolean) => void
}

export default class OrderTrackingCheckbox extends React.PureComponent<OrderTrackingCheckboxProps> {
  onChange = (e: React.ChangeEvent<HTMLInputElement>) => this.props.onChange(this.props.item, e.target.checked)
  buildId = (item: OrderResultRecordIdentifier) => `${this.props.idPrefix}_${item.TestDetailID}_${item.TestDetailClinicalID}`
  render() { return <Checkbox checked={this.props.checked} onChange={this.onChange} id={this.buildId(this.props.item)} /> }
}
